module.exports = __webpack_public_path__ + "static/media/ic_tick.6e30a7e3.svg";